(() => {
  const selectors = {
    section: '.sas-smt-column-and-text',
    carousel: '.sas-smt-column-and-text__carousel',
    nav: '.sas-smt-column-and-text__nav',
    pagination: '.sas-smt-column-and-text__pagination',
  };

  const initSlider = (section) => {
    const carousel = section.querySelector(selectors.carousel);
    if (!carousel || carousel.dataset.initialized === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const columns = parseFloat(carousel.dataset.columns || '1');
    const tabletColumns = parseFloat(carousel.dataset.columnsTablet || '2.2');
    const mobileColumns = parseFloat(carousel.dataset.columnsMobile || '1.2');
    const spaceBetween = parseInt(carousel.dataset.space || '16', 10);
    const isFullWidth = carousel.dataset.fullWidth === 'true';
    const loopRequested = carousel.dataset.loop === 'true';
    const autoplayRequested = carousel.dataset.autoplay === 'true';
    const slideCount = carousel.querySelectorAll('.swiper-slide').length;
    const loopEnabled = loopRequested && slideCount > columns;
    const nav = section.querySelector(selectors.nav);
    const pagination = section.querySelector(selectors.pagination);


    const options = {
      slidesPerView: Number.isFinite(columns) ? columns : 1,
      spaceBetween,
      speed: autoplayRequested ? 900 : 500,
      loop: loopEnabled,
      breakpoints: {
        0: {
          slidesPerView: Number.isFinite(mobileColumns) ? mobileColumns : 1.2,
          autoHeight: true,
        },
        750: {
          slidesPerView: Number.isFinite(tabletColumns) ? tabletColumns : 2.2,
          ...(isFullWidth ? { slidesOffsetBefore: 20 } : {}),
          watchOverflow: true,
        },
        1220: {
          slidesPerView: Number.isFinite(columns) ? columns : 3.2,
          ...isFullWidth ? { slidesOffsetBefore: 30 } : {},
          autoHeight: false,
        },
        1250: isFullWidth ? { slidesOffsetBefore: 65 } : {},
        1300: isFullWidth ? { slidesOffsetBefore: 70 } : {},
        1350: isFullWidth ? { slidesOffsetBefore: 80 } : {},
        1366: isFullWidth ? { slidesOffsetBefore: 90 } : {},
        1440: isFullWidth ? { slidesOffsetBefore: 140 } : {},
        1500: isFullWidth ? { slidesOffsetBefore: 180 } : {},
        1550: isFullWidth ? { slidesOffsetBefore: 200 } : {},
        1600: isFullWidth ? { slidesOffsetBefore: 225 } : {},
        1650: isFullWidth ? { slidesOffsetBefore: 240 } : {},
        1700: isFullWidth ? { slidesOffsetBefore: 260 } : {},
        1750: isFullWidth ? { slidesOffsetBefore: 300 } : {},
        1800: isFullWidth ? { slidesOffsetBefore: 330 } : {},
        1850: isFullWidth ? { slidesOffsetBefore: 370 } : {},
        1921: isFullWidth ? { slidesOffsetBefore: 0 } : {},
      },
    };

    if (autoplayRequested) {
      options.autoplay = {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    if (nav) {
      options.navigation = {
        nextEl: section.querySelector('.sas-smt-column-and-text__arrow--next'),
        prevEl: section.querySelector('.sas-smt-column-and-text__arrow--prev'),
      };
    }

    if (pagination) {
      options.pagination = {
        el: pagination,
        clickable: true,
      };
    }

    const swiper = new Swiper(carousel, options);
    const updateNavVisibility = () => {
      if (!nav) return;
      const currentBreakpoint = swiper.currentBreakpoint;
      const breakpointParams =
        currentBreakpoint && swiper.params.breakpoints
          ? swiper.params.breakpoints[currentBreakpoint]
          : null;
      const activeSlidesPerView =
        breakpointParams && typeof breakpointParams.slidesPerView !== 'undefined'
          ? breakpointParams.slidesPerView
          : swiper.params.slidesPerView;
      const slidesPerViewNumber =
        typeof activeSlidesPerView === 'number' && Number.isFinite(activeSlidesPerView)
          ? activeSlidesPerView
          : columns;
      nav.style.display = slideCount > slidesPerViewNumber ? '' : 'none';
    };

    const updatePaginationVisibility = () => {
      if (!pagination) return;
      const currentBreakpoint = swiper.currentBreakpoint;
      const breakpointParams =
        currentBreakpoint && swiper.params.breakpoints
          ? swiper.params.breakpoints[currentBreakpoint]
          : null;
      const activeSlidesPerView =
        breakpointParams && typeof breakpointParams.slidesPerView !== 'undefined'
          ? breakpointParams.slidesPerView
          : swiper.params.slidesPerView;
      const slidesPerViewNumber =
        typeof activeSlidesPerView === 'number' && Number.isFinite(activeSlidesPerView)
          ? activeSlidesPerView
          : columns;
      pagination.style.display = slideCount > slidesPerViewNumber ? '' : 'none';
    };

    updateNavVisibility();
    updatePaginationVisibility();
    swiper.on('breakpoint', () => {
      updateNavVisibility();
      updatePaginationVisibility();
    });
    swiper.on('resize', () => {
      updateNavVisibility();
      updatePaginationVisibility();
    });

    carousel.dataset.initialized = 'true';
    carousel.swiperInstance = swiper;
  };

  const initAll = () => {
    document.querySelectorAll(selectors.section).forEach(initSlider);
  };

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target?.querySelector?.(selectors.section);
    if (section) {
      initSlider(section);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
